/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-03-31 13:59:29
 * @LastEditors: m
 * @LastEditTime: 2020-08-24 10:31:40
 */

// const httpURL = "http://es.10led.com:8069/api";
// const fileUrl = "http://es.10led.com:8069/download/";
// const Name = "测试CRM系统";
// const LOGO = require('../img/wylogo.png');



// const httpURL = "https://api.scxydled.com/api";
// const fileUrl = "https://api.scxydled.com/download/";
// const Name = "四川新元达CRM系统";
// const LOGO = require('../img/xydlogo.png');


// const httpURL = "https://api.ahzh66.com/api";
// const fileUrl = "https://api.ahzh66.com/download/";
// const Name = "安徽中恒CRM系统";
// const LOGO = require('../img/anzh.png');

const httpURL = "https://api.hhkyled.com/api";
const fileUrl = "https://api.hhkyled.com/download/";
const Name = "湖北汇恒科益CRM系统";
const LOGO = require('../img/hhky-logo.png');

export default {
    httpURL,
    fileUrl,
    Name,
    LOGO,
};
//说明：启动命令npm  run  dev   打包命令：npm run build